module.exports = __webpack_public_path__ + "img/bonus@2x.ebbdbbfd.png";